import fetch from "../apiconfig/index";
// 用户登陆
export function Login(params) {
  return fetch.post(`/api/User/Login/?t=` + new Date().getTime(), params);
}
// 注销用户
export function Logout(params) {
  return fetch.get(`/api/User/Logout/?t=` + new Date().getTime(), params);
}
// 用户注册
export function Register(params) {
  return fetch.post(
    `/api/v1/admin/Visitor/Register/?t=` + new Date().getTime(),
    params
  );
}
// 重置密码
export function UserReset(params) {
  return fetch.post(
    `/api/v1/admin/Role/UserReset/?t=` + new Date().getTime(),
    params
  );
}
//记录页面访问时长
export function AddPageTime(params) {
  return fetch.post(
    `/api/public/User/AddPageTime/?t=` + new Date().getTime(),
    params
  );
}
// 获取皮肤信息
export function GetSkinView(params) {
  return fetch.get(
    `/api/public/Skin/GetSkinView/?t=` + new Date().getTime(),
    params
  );
}
// 修改皮肤信息
export function UpSkin(params) {
  return fetch.post(
    `/api/public/Skin/UpSkin/?t=` + new Date().getTime(),
    params
  );
}
// 获取消息列表
export function GetMessageList(params) {
  return fetch.get(
    `/api/v1/student/Msg/GetMessageList/?t=` + new Date().getTime(),
    params
  );
}
// 接入微信登录平台
export function LoginWeChat(params) {
  return fetch.get(
    `/api/public/OAuth/WeChat_Login/?t=` + new Date().getTime(),
    params
  );
}
// 微信登录
export function WeChat_ChangeState(params) {
  return fetch.get(
    `/api/public/OAuth/WeChat_ChangeState/?t=` + new Date().getTime(),
    params
  );
}
/* =======================================
   =====================  管理员  =============
   ======================================= */
/* ==============================数据统计============================== */
//数据统计
export function GetStatistics(params) {
  return fetch.get(
    `/api/v1/admin/Stat/GetStatistics/?t=` + new Date().getTime(),
    params
  );
}

/* //获取校级统计数据-实验列表
export function GetExperimentArr(params) {
    return fetch.get(`/api/v1/teacher/Exp/GetExperimentArr/?t=`+new Date().getTime(), params)
}
//学院统计数据-基础
export function GetFieldCollegeTj(params) {
    return fetch.get(`/api/v1/teacher/Count/GetFieldCollegeTj/?t=`+new Date().getTime(), params)
}
// 学院统计数据-时间展示
export function GetFieldCollegeSj(params) {
    return fetch.get(`/api/v1/teacher/Count/GetFieldCollegeSj/?t=`+new Date().getTime(), params)
}
// 学院统计数据-成绩分段统计
export function GetFieldCollegeScoreD(params) {
    return fetch.get(`/api/v1/teacher/Count/GetFieldCollegeScoreD/?t=`+new Date().getTime(), params)
}
// 学院统/教师计数据-成绩统计
export function GetFieldCollegeScore(params) {
    return fetch.get(`/api/v1/teacher/Count/GetFieldCollegeScore/?t=`+new Date().getTime(), params)
}
// 教师统计数据-本周教学任务
export function GetFieldTchCourse(params) {
    return fetch.get(`/api/v1/teacher/Count/GetFieldTchCourse/?t=`+new Date().getTime(), params)
}
// 教师统计数据-学习近况
export function GetFieldTchCoursePH(params) {
    return fetch.get(`/api/v1/teacher/Count/GetFieldTchCoursePH/?t=`+new Date().getTime(), params)
} */
/* ==============================校级栏目============================== */
//获取校级栏目列表
export function GetSchoolColumnList(params) {
  return fetch.get(
    `/api/v1/admin/Door/GetSchoolColumnList/?t=` + new Date().getTime(),
    params
  );
}
//获取校级栏目信息
export function GetSchoolColumnById(params) {
  return fetch.get(
    `/api/v1/admin/Door/GetSchoolColumnById/?t=` + new Date().getTime(),
    params
  );
}
//修改校级栏目信息
export function EditSchoolColumnById(params) {
  return fetch.post(
    `/api/v1/admin/Door/GetSchoolColumnById/?t=` + new Date().getTime(),
    params
  );
}

/* ==============================校级轮播图列表============================== */
// 获取校级轮播图类别列表
export function GetSchoolImageTypeList(params) {
  return fetch.get(
    `/api/v1/admin/Door/GetSchoolImageTypeList/?t=` + new Date().getTime(),
    params
  );
}
//获取校级轮播图列表
export function GetSchoolImageList(params) {
  return fetch.get(
    `/api/v1/admin/Door/GetSchoolImageList/?t=` + new Date().getTime(),
    params
  );
}
//获取校级轮播图信息
export function GetSchoolImageById(params) {
  return fetch.get(
    `/api/v1/admin/Door/GetSchoolImageById/?t=` + new Date().getTime(),
    params
  );
}
//修改校级轮播图信息
export function AmendSchoolImageById(params) {
  return fetch.post(
    `/api/v1/admin/Door/GetSchoolImageById/?t=` + new Date().getTime(),
    params
  );
}
//添加校级轮播图信息
export function AddSchoolImage(params) {
  return fetch.post(
    `/api/v1/admin/Door/AddSchoolImage/?t=` + new Date().getTime(),
    params
  );
}
//删除校级轮播图信息
export function DelSchoolImage(params) {
  return fetch.get(
    `/api/v1/admin/Door/DelSchoolImageById/?t=` + new Date().getTime(),
    params
  );
}

/* ==============================校级栏目文章列表============================== */
//获取校级栏目文章列表
export function GetSchoolArticleList(params) {
  return fetch.get(
    `/api/v1/admin/Door/GetSchoolArticleList/?t=` + new Date().getTime(),
    params
  );
}
//获取校级栏目文章信息
export function GetSchoolArticleById(params) {
  return fetch.get(
    `/api/v1/admin/Door/GetSchoolArticleById/?t=` + new Date().getTime(),
    params
  );
}
//修改校级栏目文章信息
export function AmendSchoolArticleById(params) {
  return fetch.post(
    `/api/v1/admin/Door/GetSchoolArticleById/?t=` + new Date().getTime(),
    params
  );
}
//添加校级栏目文章信息
export function AddSchoolArticle(params) {
  return fetch.post(
    `/api/v1/admin/Door/AddSchoolArticle/?t=` + new Date().getTime(),
    params
  );
}
//删除校级栏目文章信息
export function DelSchoolArticle(params) {
  return fetch.get(
    `/api/v1/admin/Door/DelSchoolArticleById/?t=` + new Date().getTime(),
    params
  );
}

/* ==============================学院信息============================== */

//获取学院列表
export function GetCollegeList(params) {
  return fetch.get(
    `/api/v1/admin/College/GetCollegeList/?t=` + new Date().getTime(),
    params
  );
}
//获取学院信息
export function GetCollegeById(params) {
  return fetch.get(
    `/api/v1/admin/College/GetCollegeById/?t=` + new Date().getTime(),
    params
  );
}
//获取选修学院信息
export function GetOptionalClassIdList(params) {
  return fetch.get(
    `/api/v1/admin/Class/GetOptionalClassIdList/?t=` + new Date().getTime(),
    params
  );
}

//添加学院信息
export function AddCollege(params) {
  return fetch.post(
    `/api/v1/admin/College/AddCollege/?t=` + new Date().getTime(),
    params
  );
}
//修改学院信息
export function AmendCollege(params) {
  return fetch.post(
    `/api/v1/admin/College/GetCollegeById/?t=` + new Date().getTime(),
    params
  );
}
//删除学院信息
export function DelCollege(params) {
  return fetch.get(
    `/api/v1/admin/College/DelCollegeById/?t=` + new Date().getTime(),
    params
  );
}

/* ==============================院级栏目============================== */

//获取学院栏目子栏目列表
export function GetCollegeColumnList(params) {
  return fetch.get(
    `/api/v1/admin/College/GetCollegeColumnList/?t=` + new Date().getTime(),
    params
  );
}
//获取学院栏目信息
export function GetCollegeColumnById(params) {
  return fetch.get(
    `/api/v1/admin/College/GetCollegeColumnById/?t=` + new Date().getTime(),
    params
  );
}
//修改学院栏目信息
export function AmendCollegeColumn(params) {
  return fetch.post(
    `/api/v1/admin/College/GetCollegeColumnById/?t=` + new Date().getTime(),
    params
  );
}
//添加子栏目信息
export function AddCollegeSub(params) {
  return fetch.post(
    `/api/v1/admin/College/AddCollegeSub/?t=` + new Date().getTime(),
    params
  );
}
//获取子栏目信息
export function GetSubColumnById(params) {
  return fetch.get(
    `/api/v1/admin/College/GetSubColumnById/?t=` + new Date().getTime(),
    params
  );
}
//修改子栏目信息
export function AmendSubColumn(params) {
  return fetch.post(
    `/api/v1/admin/College/GetSubColumnById/?t=` + new Date().getTime(),
    params
  );
}
//删除子栏目信息
export function DelCollegeSubById(params) {
  return fetch.get(
    `/api/v1/admin/College/DelCollegeSubById/?t=` + new Date().getTime(),
    params
  );
}

/* ==============================院级轮播图列表============================== */
//获取轮播图类别列表
export function GetRotationImageTypeList(params) {
  return fetch.get(
    `/api/v1/admin/College/GetRotationImageTypeList/?t=` + new Date().getTime(),
    params
  );
}
//获取轮播图列表
export function GetRotationImageList(params) {
  return fetch.get(
    `/api/v1/admin/College/GetRotationImageList/?t=` + new Date().getTime(),
    params
  );
}
//获取轮播图信息
export function GetRotationImageById(params) {
  return fetch.get(
    `/api/v1/admin/College/GetRotationImageById/?t=` + new Date().getTime(),
    params
  );
}
//修改轮播图信息
export function AmendRotation(params) {
  return fetch.post(
    `/api/v1/admin/College/GetRotationImageById/?t=` + new Date().getTime(),
    params
  );
}
//添加学院轮播图信息
export function AddRotationImage(params) {
  return fetch.post(
    `/api/v1/admin/College/AddRotationImage/?t=` + new Date().getTime(),
    params
  );
}
//删除轮播图信息
export function DelRotationImage(params) {
  return fetch.get(
    `/api/v1/admin/College/DelRotationImageById/?t=` + new Date().getTime(),
    params
  );
}
/* ==============================院级栏目文章列表============================== */
//获取栏目文章列表
export function GetCollegeArticleList(params) {
  return fetch.get(
    `/api/v1/admin/College/GetCollegeArticleList/?t=` + new Date().getTime(),
    params
  );
}
//获取栏目文章信息
export function GetCollegeArticleById(params) {
  return fetch.get(
    `/api/v1/admin/College/GetCollegeArticleById/?t=` + new Date().getTime(),
    params
  );
}
//修改栏目文章信息
export function AmendCollegeArticle(params) {
  return fetch.post(
    `/api/v1/admin/College/GetCollegeArticleById/?t=` + new Date().getTime(),
    params
  );
}
//添加栏目文章信息
export function AddCollegeArticle(params) {
  return fetch.post(
    `/api/v1/admin/College/AddCollegeArticle/?t=` + new Date().getTime(),
    params
  );
}
//删除栏目文章信息
export function DelCollegeArticle(params) {
  return fetch.get(
    `/api/v1/admin/College/DelCollegeArticleById/?t=` + new Date().getTime(),
    params
  );
}

/* ==============================班级============================== */
//添加班级信息
export function AddClass(params) {
  return fetch.post(
    `/api/v1/admin/Class/AddClass/?t=` + new Date().getTime(),
    params
  );
}
//删除班级信息
export function DelClassById(params) {
  return fetch.get(
    `/api/v1/admin/Class/DelClassById/?t=` + new Date().getTime(),
    params
  );
}
//修改班级信息
export function AmendClassById(params) {
  return fetch.post(
    `/api/v1/admin/Class/GetClassById/?t=` + new Date().getTime(),
    params
  );
}
//获取班级信息
export function GetClassById(params) {
  return fetch.get(
    `/api/v1/admin/Class/GetClassById/?t=` + new Date().getTime(),
    params
  );
}
//获取班级列表
export function GetClassList(params) {
  return fetch.get(
    `/api/v1/admin/Class/GetClassList/?t=` + new Date().getTime(),
    params
  );
}

/* ==============================教师管理============================== */
//获取教师角色列表
export function GetPerList(params) {
  return fetch.get(
    `/api/v1/admin/Per/GetPerList/?t=` + new Date().getTime(),
    params
  );
}
//获取班级列表
export function GetClassListById(params) {
  return fetch.get(
    `/api/v1/admin/Class/GetClassIdList/?t=` + new Date().getTime(),
    params
  );
}
//获取教师列表
export function GetTeacherList(params) {
  return fetch.get(
    `/api/v1/admin/Role/GetTeacherList/?t=` + new Date().getTime(),
    params
  );
}
//获取教师信息
export function GetTeacherByTeacherId(params) {
  return fetch.get(
    `/api/v1/admin/Role/GetTeacherById/?t=` + new Date().getTime(),
    params
  );
}
//添加教师信息
export function AddTeacher(params) {
  return fetch.post(
    `/api/v1/admin/Role/AddTeacher/?t=` + new Date().getTime(),
    params
  );
}
//修改教师信息
export function AmendTeacher(params) {
  return fetch.post(
    `/api/v1/admin/Role/GetTeacherById/?t=` + new Date().getTime(),
    params
  );
}
//删除教师信息
export function delTeacher(params) {
  return fetch.get(`/api/v1/admin/Role/DelTeacherById`, params);
}
/* ==============================班级管理============================== */
//获取学生列表
export function GetStudentList(params) {
  return fetch.get(
    `/api/v1/admin/Role/GetStudentList/?t=` + new Date().getTime(),
    params
  );
}
//获取学生信息
export function GetStudentById(params) {
  return fetch.get(
    `/api/v1/admin/Role/GetStudentById/?t=` + new Date().getTime(),
    params
  );
}
//添加学生信息
export function AddStudent(params) {
  return fetch.post(
    `/api/v1/admin/Role/AddStudent/?t=` + new Date().getTime(),
    params
  );
}
//修改学生信息
export function AmendStudent(params) {
  return fetch.post(
    `/api/v1/admin/Role/GetStudentById/?t=` + new Date().getTime(),
    params
  );
}
//删除学生信息
export function delStudent(params) {
  return fetch.get(
    `/api/v1/admin/Role/DelStudentById/?t=` + new Date().getTime(),
    params
  );
}
/* ==============================访客管理============================== */
//获取访客角色列表
export function GetVisitorPerList(params) {
  return fetch.get(
    `/api/v1/admin/Per/GetVisitorPerList/?t=` + new Date().getTime(),
    params
  );
}
//获取访客列表
export function GetVisitorList(params) {
  return fetch.get(
    `/api/v1/admin/Role/GetVisitorList/?t=` + new Date().getTime(),
    params
  );
}
//获取访客信息
export function GetVisitorByTeacherId(params) {
  return fetch.get(
    `/api/v1/admin/Role/GetVisitorById/?t=` + new Date().getTime(),
    params
  );
}
//添加访客信息
export function AddVisitor(params) {
  return fetch.post(
    `/api/v1/admin/Role/AddVisitor/?t=` + new Date().getTime(),
    params
  );
}
//修改访客信息
export function AmendVisitor(params) {
  return fetch.post(
    `/api/v1/admin/Role/GetVisitorById/?t=` + new Date().getTime(),
    params
  );
}
//删除访客信息
export function delVisitor(params) {
  return fetch.get(`/api/v1/admin/Role/DelVisitorById/`, params);
}
/* ==============================评价管理============================== */
//获取所有实验（无分页）

export function GetExperimentArr(params) {
  return fetch.get(
    `/api/public/General/GetExperimentArr/?t=` + new Date().getTime(),
    params
  );
}
//获取评价列表
export function GetTalkList(params) {
  return fetch.get(
    `/api/v1/admin/Dis/GetDiscussList/?t=` + new Date().getTime(),
    params
  );
}
//删除评价列表
export function delTalk(params) {
  return fetch.get(
    `/api/v1/admin/Dis/DelDiscussById/?t=` + new Date().getTime(),
    params
  );
}
//批量删除评价信息
export function delCheckedTalk(params) {
  return fetch.post(
    `/api/v1/admin/Dis/DelDiscussById/?t=` + new Date().getTime(),
    params
  );
}

/* ==============================权限管理============================== */

//添加教师角色信息
export function AddPer(params) {
  return fetch.post(
    `/api/v1/admin/Per/AddPer/?t=` + new Date().getTime(),
    params
  );
}
//删除教师角色信息
export function delPer(params) {
  return fetch.get(
    `/api/v1/admin/Per/DelPerById/?t=` + new Date().getTime(),
    params
  );
}
//修改教师角色信息
export function AmendPer(params) {
  return fetch.post(
    `/api/v1/admin/Per/GetPerById/?t=` + new Date().getTime(),
    params
  );
}
// 获取教师角色信息
export function GetPerById(params) {
  return fetch.get(
    `/api/v1/admin/Per/GetPerById/?t=` + new Date().getTime(),
    params
  );
}
// 编辑教师菜单权限
export function AddMainMenu(params) {
  return fetch.post(
    `/api/v1/admin/Per/AddMainMenu/?t=` + new Date().getTime(),
    params
  );
}
//获取教师权限菜单
export function GetMainMenu(params) {
  return fetch.get(
    `/api/v1/admin/Per/GetMainMenu/?t=` + new Date().getTime(),
    params
  );
}

/* ==============================注册访客权限管理============================== */

//添加注册访客信息
export function AddVisitorPer(params) {
  return fetch.post(
    `/api/v1/admin/Per/AddVisitorPer/?t=` + new Date().getTime(),
    params
  );
}
//删除注册访客信息
export function delVisitorPer(params) {
  return fetch.get(
    `/api/v1/admin/Per/DelVisitorPerById/?t=` + new Date().getTime(),
    params
  );
}
//修改注册访客信息
export function AmendVisitorPer(params) {
  return fetch.post(
    `/api/v1/admin/Per/GetVisitorPerById/?t=` + new Date().getTime(),
    params
  );
}
// 获取注册访客信息
export function GetVisitorPerById(params) {
  return fetch.get(
    `/api/v1/admin/Per/GetVisitorPerById/?t=` + new Date().getTime(),
    params
  );
}
// 编辑注册访客单权限
export function AddVisitorMainMenu(params) {
  return fetch.post(
    `/api/v1/admin/Per/AddVisitorMainMenu/?t=` + new Date().getTime(),
    params
  );
}
//获取注册访客权限菜单
export function GetVisitorMainMenu(params) {
  return fetch.get(
    `/api/v1/admin/Per/GetVisitorMainMenu/?t=` + new Date().getTime(),
    params
  );
}
/* ==============================系统日志管理============================== */
//获取系统日志列表
export function GetLoginLogList(params) {
  return fetch.get(
    `/api/v1/admin/log/GetLoginLogList/?t=` + new Date().getTime(),
    params
  );
}
//获取访问页面详情
export function GetLoginLogGuid(params) {
  return fetch.get(
    `/api/v1/admin/log/GetLoginLogGuid/?t=` + new Date().getTime(),
    params
  );
}
/* ==============================操作日志管理============================== */
//获取操作日志列表
export function GetRecordLogList(params) {
  return fetch.get(
    `/api/v1/admin/log/GetRecordLogList/?t=` + new Date().getTime(),
    params
  );
}
/* ==============================数据备份管理============================== */
// 数据库操作日志列表
export function GetBackupList(params) {
  return fetch.get(
    `/api/v1/admin/DB/GetBackupList/?t=` + new Date().getTime(),
    params
  );
}
// 数据库手动备份
export function AddBackup(params) {
  return fetch.get(
    `/api/v1/admin/DB/AddBackup/?t=` + new Date().getTime(),
    params
  );
}
// 数据库手动恢复
export function AddRestore(params) {
  return fetch.post(
    `/api/v1/admin/DB/AddRestore/?t=` + new Date().getTime(),
    params
  );
}
// 数据库可恢复列表
export function GetBackupArr(params) {
  return fetch.get(
    `/api/v1/admin/DB/GetBackupArr/?t=` + new Date().getTime(),
    params
  );
}

//更新数据中心教师的信息
export function AddCenterTeacherInfo(params) {
  return fetch.get(
    `/api/v1/admin/DataCenter/AddCenterTeacherInfo/?t=` + new Date().getTime(),
    params
  );
}

//更新数据中心学生的信息
export function AddCenterStudentInfo(params) {
  return fetch.get(
    `/api/v1/admin/DataCenter/AddCenterStudentInfo/?t=` + new Date().getTime(),
    params
  );
}

//自动登录
export function casLogin(params) {
  return fetch.post("/api/User/Login/cas/?ticket=" + params);
}
